/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 機器情報
 */
export interface Sgkb575aResDeviceInfo {
    /** 
     * 高効率給湯器：半角英数混在
     */
    highefficiencyWaterheater?: string;
    /** 
     * 高効率給湯器有無名称：全角文字
     */
    highefficiencywaterheaterUmuAname?: string;
    /** 
     * その他給湯器：半角英数混在
     */
    etcWaterheater?: string;
    /** 
     * その他給湯器有無名称：全角文字
     */
    etcwaterheaterUmuAname?: string;
    /** 
     * 厨房機器：半角英数混在
     */
    kitchenequipment?: string;
    /** 
     * 厨房機器有無名称：全角文字
     */
    kitchenequipmentUmuAname?: string;
    /** 
     * 床暖房：半角英数混在
     */
    yukadanbo?: string;
    /** 
     * 床暖房有無名称：全角文字
     */
    yukadanboUmuAname?: string;
    /** 
     * 浴室暖房乾燥機：半角英数混在
     */
    bathroomheatingDryer?: string;
    /** 
     * 浴室暖房乾燥機有無名称：全角文字
     */
    bathroomheatingdryerUmuAname?: string;
    /** 
     * その他暖房機：半角英数混在
     */
    etcHeatmachine?: string;
    /** 
     * その他暖房機有無名称：全角文字
     */
    etcheatmachineUmuAname?: string;
    /** 
     * 空調機器：半角英数混在
     */
    airconditioning?: string;
    /** 
     * 空調機器有無名称：全角文字
     */
    airconditioningUmuAname?: string;
    /** 
     * コージェネ機器：半角英数混在
     */
    cogenerationDevice?: string;
    /** 
     * コージェネ機器有無名称：全角文字
     */
    cogenerationdeviceUmuAname?: string;
    /** 
     * 第一群：半角英数混在
     */
    group1?: string;
    /** 
     * 第一群有無名称：全角文字
     */
    group1UmuAname?: string;
    /** 
     * 第二群：半角英数混在
     */
    group2?: string;
    /** 
     * 第二群有無名称：全角文字
     */
    group2UmuAname?: string;
    /** 
     * 第三群：半角英数混在
     */
    group3?: string;
    /** 
     * 第三群有無名称：全角文字
     */
    group3UmuAname?: string;
    /** 
     * 第四群：半角英数混在
     */
    group4?: string;
    /** 
     * 第四群有無名称：全角文字
     */
    group4UmuAname?: string;
}
